var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPath62(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 513,
    viewBox: "0 0 513 513",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512.386 391.939L434.102 262.018L433.64 262.889V261.297L396.787 200.176C396.186 198.872 395.413 197.568 394.495 196.408L433.64 132.247L434.558 130.648L468.353 75.1964C457.647 65.0326 446.023 55.8911 433.64 47.6146C427.069 43.1192 420.345 39.0497 413.305 35.2751C393.28 24.1021 371.564 15.3931 348.627 9.58057L315.135 64.6L275.534 129.633L274.927 130.648L235.471 195.537L195.415 261.297L155.966 326.179C144.197 307.162 137.619 284.953 137.619 261.297V257.856C137.619 237.188 143.369 216.893 154.289 199.017C155.352 197.136 156.422 195.386 157.65 193.65L195.877 130.648H196.022L275.534 0.144165V0H275.23C225.076 0 178.137 12.6343 137.619 34.9868C97.5555 56.9068 63.9188 88.2632 39.7594 125.858C38.8413 127.457 37.7715 129.049 36.8534 130.648C36.6946 130.648 36.8534 130.504 36.8534 130.648C35.6385 132.536 34.2511 134.711 33.1881 136.743C12.0797 173.761 0 216.146 0 261.297C0 306.434 12.0797 348.826 33.1881 385.838C33.7955 386.86 34.4029 387.869 35.0173 388.892C35.6316 389.907 36.2391 390.923 36.8534 391.795V391.939C37.7715 393.531 38.8413 395.13 39.7594 396.729C51.6803 415.307 65.9067 432.292 82.1142 447.384C98.6254 463.066 117.276 476.565 137.619 487.6C157.491 498.629 178.904 507.194 201.531 513L235.471 457.26L275.23 391.939H275.389L275.534 391.65L315.294 326.467L344.347 374.226L355.053 391.939H355.205L413.305 487.305C420.345 483.537 427.069 479.468 433.64 474.966C465.903 453.341 492.968 425.471 513 392.954L512.386 391.939Z",
    fill: "url(#paint0_linear_1928_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1928_3",
    x1: 240.266,
    y1: 505.073,
    x2: 246.015,
    y2: -11.2749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92EE9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2862B6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath62);
export default __webpack_public_path__ + "static/media/path62.c4788b686a6fb8e0a873267fb9f5d112.svg";
export { ForwardRef as ReactComponent };